module.exports = __webpack_public_path__ + "img/mv.db31b690.svg";